module.exports = __webpack_public_path__ + "JosephKalathil-6487c266.webp";